import React, { useCallback } from "react";
import _ from "lodash";
import { useSelector } from 'react-redux'
import EmployeeList, { EmployeeListModes } from 'components/organisms/EmployeeList'
import { AppRoutes } from 'navigations/app-routes'
import { useNavigation } from '@react-navigation/native'
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Text from "theme/Text";
import { textStyles } from 'styles/text'
import { dataConstants } from 'services/redux/data/constants'
import LoadingComponent from 'components/atoms/Loading'
import selectEmployeeConfidants from 'services/redux/data/selectors/selectEmployeeConfidants'
import VStack from 'components/atoms/stack/VStack'

const ConfidantTab = () => {
	const navigation = useNavigation();
	
	const _confidants = useSelector( selectEmployeeConfidants )
	const _confidantsLoaded = useSelector( state => {
		return state.data[dataConstants.EMPLOYEES_CONFIDANTS_LOADED];
	} )
	
	const openEro = useCallback(
		( employee ) => {
			navigation.navigate( AppRoutes.CONFIDANT_COWORKER, {
				employee: employee.guid,
			} );
		},
		[ _confidants ]
	);
	
	const sortedConfidants = _.sortBy( _confidants, ( confidant ) => {
		// has bookings +1
		// has scans + 2 or has no scans + 1
		return ( _.size( _.get( confidant, 'scans', [] ) ) > 0 ? 1 : 2 ) + ( _.size( _.get( confidant, 'bookings', [] ) ) > 0 ? 0 : 1 ) ;
	});
	
	if(  _confidantsLoaded === false ){
		return <LoadingComponent size={'m'} />;
	}
	
	return (
		<VStack>
			<ThemedBlock shadow mediumPadding textSmall>
				<Text style={ textStyles.textCenter }>
					{ i18n.t( 'pages.coworker_confidants.description')}
				</Text>
			</ThemedBlock>
			
			<EmployeeList
				employees={ sortedConfidants }
				mode={ EmployeeListModes.CONFIDANT }
				onPress={ openEro }
				showDetails={ true }
				noResultText={ i18n.t( 'pages.coworker_confidants.no_confidants')}
			/>
		</VStack>
	);
}

export default ConfidantTab
